export default "__VITE_ASSET__kvEJWgAo__"